module.exports = __webpack_public_path__ + "img/icon-quote.eb020bc7.svg";